<template>
<Modal 
    :id="'cmp_royalty-statements-check_contracts_modal'"
    @cancelled="onCancelClick"  
>
    <template slot="header">
     
    </template>
    <template slot="body">

      <div style="height:400px">   


        <NTable
            id="catalog-releases-releases_list"
            class="h1 dbox1"
            :config="tableConfig"
            :headers="contactHeaders"
            :items="list"                
        >
                <template v-slot:item="{ item, tdcon }">
                <tr>
                    <td v-bind="tdcon('catalog_no')">
                        <span>{{$t(item['catalog_no'])}}</span>
                    </td>
                    <td v-bind="tdcon('royalty_account')">
                        <span>{{ item["royalty_account_name"] }}</span>
                    </td>
                    <td v-bind="tdcon('contract_name')">
                        <div class="ut-flex" style="white-space: break-spaces;">{{ item["contract_name"] }}</div>
                    </td>
                    <td v-bind="tdcon('share')">
                        <span>{{item['share']}}</span>   
                    </td>
                    <td v-bind="tdcon('rata1')">
                        <span>{{item['rata1']}}</span>
                    </td>
                    <td v-bind="tdcon('rata2')">
                        <span>{{item['rata2']}}</span>
                    </td>
                    
                    <td v-bind="tdcon('exclude')">
                        <div class="ut-rowcen">
                            <div class="dt-checkbox v2 s1">
                            <input
                                type="checkbox"
                                :name="'external_id2'"
                                :id="'external_id2'"
                                :disabled="addedProducts.has(item['primaryKey'])"
                                :checked="excludedProducts.has(item['primaryKey']) "
                                @click="(e) => onCheckBoxChange('exclude',e, item)"
                            />
                            <div class="checkmark"></div>
                            </div>
                        </div>
                        
                    </td>
                    <td v-bind="tdcon('add_product')">
                        <div class="ut-rowcen">
                            <div class="dt-checkbox v2 s1">
                            <input
                                type="checkbox"
                                :name="'external_id2'"
                                :id="'external_id2'"
                                :disabled="excludedProducts.has(item['primaryKey'])"
                                :checked="addedProducts.has(item['primaryKey']) "
                                @click="(e) => onCheckBoxChange('add',e, item)"
                            />
                            <div class="checkmark"></div>
                            </div>
                        </div>
                        
                    </td>
                   
                    
                </tr>
                </template>
            </NTable>
        </div>
    
     </template>
    <template slot="options">

        <p>
            The above Products are not part of their release contract.
            Please eiher add <br/>
            (Royalties will be calculated) or exclude (No Royalties will be calculated). 
            <br/> If you have any questions, please contact us.
        </p>
        <button class="dt-button s7" @click="onCancelClick" style="margin-left: 10px;" >Cancel</button>
        <button class="dt-button s7 v1" @click="onOKClicked" style="margin-left: 10px;">Confirm Selection</button>
        <button v-if="selectAll" class="dt-button s7 v1" @click="onSelectAll">Select All</button>
        <button v-if="!selectAll" class="dt-button s7 v1" @click="onSelectNone">Select None</button>
        
        
    </template>
</Modal>
  
  
</template>

<script>
import Modal from '../../../../dt-plugins/modal/modal';
import { RoyaltyStoreNamespace as storeNS } from "../../store";
import { mapGetters, mapActions } from "vuex";
import * as ActionTypes from "../../store/types";
import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";
import { Subject } from "rxjs";
import {
  distinctUntilChanged,
  debounceTime,
} from "rxjs/operators";
import InputField from "@plugins/text-field/input-field";

import { ConfirmationService } from "@/dt-plugins/confirmation/confirmation.service";
import { createNTableConfig } from '../../../../plugins/datatable';

import { createTableHeader } from "../../../../plugins/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";

import { createModalMixin ,closeModalRoute  } from "../../../../dt-plugins/modal/modal.mixin";
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";





import {
  createTV,
  tv,
} from "../../../../models/text-value.model";

import {
  mapGetterObject,
  mapActionObject,
} from "../../../../store/global";
import { statementGetters } from '../../store/statement/getters';
import { statementActions } from '../../store/statement/actions';
import { statementServices } from '../../services/statements/statements.service';

import { MHTTPCL } from '../../../../services/http/http-client';
import { addRemoveSet } from '../../../../utility';

// import { LoadedEnd } from "../../../../dt-plugins/advanced-search/load.model";
// export const releaseListAdvancedSearchConfig = createAdvancedSearchConfig(
//   {
//     searchConfigStringKeys: [
      
//       "artist",
//       "title",
//       "start_date",
//       "end_date",
//       "indentifier",
//       "release_status",
//       "label_id",
//       "release_type",
//     ],
//     searchConfigTVMap: [
//       ["label_id", "labelsTV"],
//       ["release_type", "releaseTypeTV"],
//       ["release_status", "releaseStatusesTV"],
    
//     ],
//     // booleanSearchKeyLabelMap: {
//     //   barcode_catalog_error: "Barcode Error",
//     // },
//   }
// );

export default {
  components: {
    
    Modal,
    NTable,
    InputField,
    DTIconButton,
    ModalContainer,
   
    //AdvanceSearch,
   
  },
  mounted:async  function () {
    const res=await statementServices.missingContractsProducts();
    console.log("SHOP",res)
    
    this.productList=res.data.products
    // this.digitalAccounts=res.data.digital_accounts;
    // this.physicalAccounts=res.data.physical_accounts;

  },
  data: function () {
    return {
      productList:[],
      digitalAccounts:[],
      physicalAccounts:[],
      excludedProducts:new Set(),
      addedProducts:new Set(),
      selectAll:true
    
    };
  },
   mixins: [
    
    // createLDTHost(LDTConfig),
    
    //createModalMixin("advanceSearch"),
    // createAdvancedSearchHost(releaseListAdvancedSearchConfig, {
    //   onBeforeAdvancedSearchFetch:
    //     "onBeforeAdvancedSearchFetch",
    // }),
    
  ],

  computed: {
    // ...mapGetters(storeNS, {
    //   releasesCatalogData: "releasesCatalogData",
      
     
    // }),
    ...mapGetterObject(storeNS,statementGetters),
  
    accountsTVDigital:function(){
        return createTV(this.digitalAccounts,"account_name","account_id"); 
    },
    accountsTVPhysical:function(){
        return createTV(this.physicalAccounts,"account_name","account_id");
    },
    tableConfig: function () {
      return createNTableConfig({
        headerStyle: 2,
        headerHeight: 30,
        fullHeight: true,
        headerStyle: 3,
        rowHeight: 'auto',
      });
    },
    list: function() {
      return this.productList.map(e=>{
          return {
            ...e,
            primaryKey:e.contract_id+"__"+e.product_id
          }
      });
    },

    contactHeaders: function () {
      return [
        createTableHeader("catalog_no", {  f:1}),
        createTableHeader("royalty_account", { f:0.9}),
        createTableHeader("contract_name", { f:1.3}),
        createTableHeader("share", { ta:'right',f:0.5}),
        createTableHeader("rata1", { ta:'right',f:0.5 }),
        createTableHeader("rata2", {  ta:'right',f:0.5 }),
        createTableHeader("exclude_product", { f:0.9 }),
        createTableHeader("add_product", { ta:'center' , f:0.9 }),
      
      ];
    },
    
  },
  methods: { 
   ...mapActionObject(storeNS, statementActions),
   
   closeModal:function(){
       closeModalRoute(this);
    },
    // getItemkVal:function(item){
    //   return {
    //     ...item,
    //     primaryKey:item.contract_id+"__"+product_id
    //   }
    // },
    onCheckBoxChange:function(name,e,item){
      console.log(e.target.checked,item);
      if(name=='add'){
        this.addedProducts = addRemoveSet(
          e.target.checked,
          this.addedProducts,
          item.primaryKey
        );
      }
      else{
        this.excludedProducts = addRemoveSet(
        e.target.checked,
        this.excludedProducts,
        item.primaryKey
      );
      }
      
      
    },
   
    onOKClicked:function(){
        
        let payload=[];
        this.addedProducts.forEach(e => {
            payload.push({...this.list.find(i=>i.primaryKey==e),allow_cost_split_flag:1})
        });
        this.excludedProducts.forEach(e => {
            payload.push({...this.list.find(i=>i.primaryKey==e),exclude:1})
        });
        console.log(payload)
        statementServices.addProductsToContracts(payload);
        this.onCancelClick();

        
    },
    onCancelClick: function() {
      this.$emit("cancelled", true);
    },
    onSelectAll:function(){
         this.selectAll = false;
         this.addedProducts = new Set(this.list.map(e => e.primaryKey));
         this.excludedProducts=new Set();
    },
    onSelectNone:function(){
         this.selectAll = true;
         this.addedProducts = new Set();
         //this.excludedProducts=new Set();
    }

  
  },
};
</script>

<style lang="scss">
.cmp_royalty-statements-check_contracts_modal {
  .dt-ntable {
    .ut-flex{
      align-items:start
    }
    
    td,
    th {
        flex: 1;
        padding: 0px;
        box-sizing: border-box;
    }
  }

}
</style>